/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_Col_TotalInputs */

const en_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const de_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

const fr_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const es_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const it_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale`)
};

const nl_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal`)
};

const pl_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łącznie`)
};

const fi_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteensä`)
};

const da_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I alt`)
};

const sv_analytics_board_col_total = /** @type {(inputs: Analytics_Board_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Analytics_Board_Col_TotalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_col_total = /** @type {((inputs?: Analytics_Board_Col_TotalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_Col_TotalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_col_total(inputs)
	if (locale === "fr") return fr_analytics_board_col_total(inputs)
	if (locale === "es") return es_analytics_board_col_total(inputs)
	if (locale === "it") return it_analytics_board_col_total(inputs)
	if (locale === "nl") return nl_analytics_board_col_total(inputs)
	if (locale === "pl") return pl_analytics_board_col_total(inputs)
	if (locale === "fi") return fi_analytics_board_col_total(inputs)
	if (locale === "da") return da_analytics_board_col_total(inputs)
	if (locale === "sv") return sv_analytics_board_col_total(inputs)
	return en_analytics_board_col_total(inputs)
});